function initTrProductoCards() {

  if (window.trProductoCardsInitialized) return;

  window.trProductoCardsInitialized = true;

  let activeCard = null;
  let activePanel = null;
  let selectedVariant = null;
  let isAddingToCart = false;

  const mobileDrawer =
    document.getElementById('tramas-panel-mobile');

  const mobileDrawerContent =
    mobileDrawer?.querySelector('[data-panel-mobile-content]');

  /* =========================================
     HELPERS
  ========================================= */

  function isMobile() {
    return window.innerWidth < 990;
  }

  function getCartTrigger() {

    return (
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('.js-drawer-open-cart') ||
      document.querySelector('button[aria-controls="CartDrawer"]') ||
      document.querySelector('[data-ntm-cart]')
    );

  }

  function resetPanel(panel) {

    if (!panel) return;

    panel
      .querySelectorAll('.tr-panel-variante.is-active')
      .forEach(item => {
        item.classList.remove('is-active');
      });

    panel
      .querySelectorAll('.tr-panel-variante.is-loading')
      .forEach(item => {
        item.classList.remove('is-loading');
      });

    panel
      .querySelectorAll('.tr-panel-variante.is-added')
      .forEach(item => {
        item.classList.remove('is-added');
      });

    panel
      .querySelectorAll('.tr-panel-variante.is-error')
      .forEach(item => {
        item.classList.remove('is-error');
      });

    panel
      .querySelectorAll('.tr-panel-variante[disabled]')
      .forEach(item => {
        item.disabled = false;
      });

    panel
      .querySelectorAll('[data-anadir-carrito]')
      .forEach(button => {
        button.disabled = true;
      });

  }

  function closeActivePanel() {

    document.body.classList.remove('panel-open');

    if (activeCard) {
      activeCard.classList.remove('is-active');
    }

    if (activePanel) {
      activePanel.classList.remove('is-active');
    }

    if (mobileDrawer) {
      mobileDrawer.classList.remove('is-active');
    }

    selectedVariant = null;

    activeCard = null;
    activePanel = null;

    setTimeout(() => {

      if (
        mobileDrawer &&
        !mobileDrawer.classList.contains('is-active') &&
        mobileDrawerContent
      ) {

        mobileDrawerContent.innerHTML = '';

      }

    }, 260);

  }

  async function addVariantToCart(variantButton) {

    if (!variantButton || isAddingToCart) return;

    const variantId =
      variantButton.dataset.varianteId;

    if (!variantId) return;

    const panel =
      variantButton.closest('.panel') ||
      variantButton.closest('#tramas-panel-mobile');

    if (!panel) return;

    isAddingToCart = true;
    selectedVariant = variantId;

    panel
      .querySelectorAll('.tr-panel-variante.is-active')
      .forEach(item => {
        item.classList.remove('is-active');
      });

    variantButton.classList.add('is-active', 'is-loading');
    variantButton.classList.remove('is-error', 'is-added');
    variantButton.disabled = true;

    panel
      .querySelectorAll('[data-anadir-carrito]')
      .forEach(button => {
        button.disabled = true;
      });

    try {

      const response =
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

      if (!response.ok) {
        throw new Error('Error al añadir');
      }

      variantButton.classList.remove('is-loading');
      variantButton.classList.add('is-added');

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true
        })
      );

      resetPanel(panel);

      closeActivePanel();

      setTimeout(() => {

        const cartTrigger =
          getCartTrigger();

        if (cartTrigger) {
          cartTrigger.click();
        }

      }, 120);

    } catch(error) {

      console.error(error);

      variantButton.classList.remove('is-loading');
      variantButton.classList.add('is-error');
      variantButton.disabled = false;

    } finally {

      isAddingToCart = false;

    }

  }

  /* =========================================
     OPEN DESKTOP
  ========================================= */

  function openDesktopPanel(card, panel) {

    closeActivePanel();

    requestAnimationFrame(() => {

      card.classList.add('is-active');

      panel.classList.add('is-active');

      activeCard = card;

      activePanel = panel;

    });

  }

  /* =========================================
     OPEN MOBILE
  ========================================= */

  function openMobileDrawer(card) {

    if (
      !card ||
      !mobileDrawer ||
      !mobileDrawerContent
    ) {
      return;
    }

    closeActivePanel();

    const jsonEl =
      card.querySelector('.tr-product-panel-json');

    if (!jsonEl) return;

    try {

      const data =
        JSON.parse(jsonEl.textContent);

      mobileDrawerContent.innerHTML =
        data.html || '';

    } catch(error) {

      console.error(error);

      return;

    }

    requestAnimationFrame(() => {

      document.body.classList.add('panel-open');

      mobileDrawer.classList.add('is-active');

      activeCard = card;

      activePanel = mobileDrawer;

    });

  }

  /* =========================================
     CLICK GLOBAL
  ========================================= */

  document.addEventListener('click', async function(e) {

    /* =========================================
       OPEN PANEL
    ========================================= */

    const openButton =
      e.target.closest('[data-producto-abrir]');

    if (openButton) {

      e.preventDefault();

      const card =
        openButton.closest('.tr-producto-card');

      if (!card) return;

      if (
        activeCard &&
        activeCard === card
      ) {

        closeActivePanel();

        return;

      }

      if (isMobile()) {

        openMobileDrawer(card);

      } else {

        const panel =
          card.querySelector('[data-panel-compra]');

        if (!panel) return;

        openDesktopPanel(card, panel);

      }

      return;

    }

    /* =========================================
       CLOSE MOBILE
    ========================================= */

    const closeDrawer =
      e.target.closest('[data-close-panel-mobile]');

    if (closeDrawer) {

      e.preventDefault();

      closeActivePanel();

      return;

    }

    /* =========================================
       VARIANTES: AÑADIR DIRECTAMENTE AL CARRITO
    ========================================= */

    const variant =
      e.target.closest('.tr-panel-variante');

    if (variant) {

      if (variant.tagName === 'A') {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      await addVariantToCart(variant);

      return;

    }

    /* =========================================
       ADD TO CART ANTIGUO - FALLBACK
    ========================================= */

    const addButton =
      e.target.closest('[data-anadir-carrito]');

    if (addButton) {

      e.preventDefault();

      if (!selectedVariant) return;

      const panel =
        addButton.closest('.panel') ||
        addButton.closest('#tramas-panel-mobile');

      if (!panel) return;

      const buttons =
        panel.querySelectorAll('[data-anadir-carrito]');

      buttons.forEach(button => {
        button.disabled = true;
      });

      try {

        const response =
          await fetch('/cart/add.js', {
            method:'POST',
            headers:{
              'Content-Type':'application/json',
              'Accept':'application/json'
            },
            body:JSON.stringify({
              id:Number(selectedVariant),
              quantity:1
            })
          });

        if (!response.ok) {
          throw new Error('Error al añadir');
        }

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles:true
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles:true
          })
        );

        resetPanel(panel);

        closeActivePanel();

        setTimeout(() => {

          const cartTrigger =
            getCartTrigger();

          if (cartTrigger) {
            cartTrigger.click();
          }

        }, 120);

      } catch(error) {

        console.error(error);

        buttons.forEach(button => {
          button.disabled = false;
        });

      }

      return;

    }

    /* =========================================
       IGNORAR CLICK DENTRO
    ========================================= */

    const mobileDrawerInner =
      mobileDrawer?.querySelector('.tr-panel-mobile-inner');

    if (activePanel) {

      if (
        activePanel.id === 'tramas-panel-mobile'
      ) {

        if (
          mobileDrawerInner &&
          mobileDrawerInner.contains(e.target)
        ) {
          return;
        }

      } else {

        if (activePanel.contains(e.target)) {
          return;
        }

      }

    }

    /* =========================================
       CERRAR FUERA
    ========================================= */

    if (activePanel) {
      closeActivePanel();
    }

  }, {
    passive:false
  });

}

/* =========================================
   INIT
========================================= */

document.addEventListener('DOMContentLoaded', function() {

  initTrProductoCards();

});

document.addEventListener('shopify:section:load', function() {

  initTrProductoCards();

});